import React, { useState, useEffect } from "react";
import { useUser } from "../context/UserContext";
import api from "../utils/api";
import { useAuth } from "../context/AuthContext";
import Navbar from "./Navbar";
import "@fontsource/inter";
import OrderHistory from "./OrderHistory";
import TrackOrder from "./TrackOrder";
import Adminsidebar from "./AccountSidebar";
import AccountSidebar from "./AccountSidebar";

const ManageAccount = () => {
  const { userData, loading, setUserData } = useUser(); // Access user data and setter
  const { token } = useAuth(); // Access token from AuthContext
  const [activeTab, setActiveTab] = useState("profile"); // Toggle between "profile" and "orders"
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
  });
  const [orders, setOrders] = useState([]); // Store dumb
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (userData) {
      setFormData({
        fullName: userData.fullName || "",
        email: userData.email || "",
        password: "",
      });
    }

    // Dummy orders for "My Orders"
    setOrders([
      { id: 1, item: "FIFA 23 Coins - Xbox", date: "2024-11-01", amount: "$20.00" },
      { id: 2, item: "FIFA 23 Coins - PlayStation", date: "2024-11-15", amount: "$35.00" },
    ]);
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSaveChanges = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!userData?._id) {
      setError("User not found.");
      return;
    }

    try {
      const dataToUpdate = {
        fullName: formData.fullName,
        ...(formData.password && { password: formData.password }), // Only include password if it's provided
      };

      const response = await api.put(`/users/${userData._id}`, dataToUpdate, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Update user data in context
      setUserData(response.data);

      setMessage("Profile updated successfully!");
      setFormData({ ...formData, password: "" }); // Reset password field
    } catch (err) {
      setError(err.response?.data?.error || "An error occurred while updating user data.");
    }
  };

  if (loading) {
    return <p>Loading user data...</p>;
  }

  return (
    <>


      <div className="min-h-screen bg-[#191919] text-white flex">
        {/* Sidebar */}
        <AccountSidebar />

        {/* Main Content */}
        <div className="hidden lg:block w-1/2 bg-primary p-8 mt-32 mb-32 my-8 rounded-lg shadow-lg">
          {activeTab === "profile" ? (
            <>
              <h2 className="text-2xl font-bold mb-6 text-black bg-primary text-center font-inter">Edit Your Profile</h2>
              <form onSubmit={handleSaveChanges} className="space-y-4 font-inter">
                <div>
                  <label className="block text-sm font-medium mb-1 text-black">Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded-lg bg-[#191919] text-yellow-300 focus:outline-none focus:ring focus:ring-yellow-400"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-black">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    className="w-full px-4 py-2 rounded-lg bg-[#191919] text-yellow-300 focus:outline-none"
                    readOnly
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-black">Password</label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded-lg bg-[#191919] text-white focus:outline-none focus:ring focus:ring-yellow-400"
                    placeholder="Enter a new password"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 text-black">Confirm Password</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    className="w-full px-4 py-2 rounded-lg bg-[#191919] text-white focus:outline-none focus:ring focus:ring-yellow-400"
                    placeholder="Confirm your new password"
                  />
                </div>
                <div className="flex justify-between">
                  <button
                    type="button"
                    onClick={() =>
                      setFormData({
                        ...formData,
                        password: "", // Reset the password field
                        confirmPassword: "" // Also reset the confirm password field
                      })
                    }
                    className="bg-[#191919] text-primary px-4 py-2 rounded-lg hover:bg-gray-800"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-[#191919] text-primary px-4 py-2 rounded-lg hover:bg-gray-800"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
              {message && <p className="text-green-500 mt-4 text-center">{message}</p>}
              {error && <p className="text-red-500 mt-4 text-center">{error}</p>}
            </>
          ) : (
            <>
              <div className="w-full">
                {/* <OrderHistory /> */}
                <TrackOrder />
              </div>
            </>
          )}
        </div>

        <div className="lg:hidden w-full max-w-sm bg-primary p-6 mt-8 mb-8 ml-10 mr-10 h-[500px] rounded-lg shadow-lg">
          <h2 className="text-lg font-bold mb-4 text-black text-center mt-9 font-inter font-medium">Edit Your Profile</h2>
          <form onSubmit={handleSaveChanges} className="space-y-4">
            {/* Full Name */}
            <div>
              <label className="block text-sm font-medium text-black mb-3 font-inter">Full Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className="w-full px-4 py-2 bg-[#191919] text-yellow-300 focus:outline-none focus:ring focus:ring-yellow-400 font-inter"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-black mb-3 font-inter">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                className="w-full px-4 py-2 bg-[#191919] text-yellow-300 focus:outline-none font-inter"
                readOnly
              />
            </div>

            {/* Password */}
            <div>
              <label className="block text-sm font-medium text-black mb-3 font-inter">Password</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full px-4 py-2 bg-[#191919] text-white focus:outline-none focus:ring focus:ring-yellow-400 font-inter"
                placeholder="Enter a new password"
              />
            </div>

            {/* Buttons */}
            <div className="flex space-x-4">
              <button
                type="button"
                onClick={() =>
                  setFormData({
                    ...formData,
                    password: "", // Reset the password field
                  })
                }
                className="text-black px-4 py-2 hover:bg-gray-800 font-inter"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-[#191919] text-primary px-4 py-2 hover:bg-gray-800 font-inter"
              >
                Save Changes
              </button>
            </div>
          </form>

          {/* Success and Error Messages */}
          {message && <p className="text-green-500 mt-4 text-center font-inter">{message}</p>}
          {error && <p className="text-red-500 mt-4 text-center font-inter">{error}</p>}
        </div>



        {/* Right Section */}
        <div className="hidden lg:block w-1/4 bg-[#191919] px-6 py-10 text-right mt-16 ">
          <h3 className="text-lg font-bold font-inter text-primary">
            Hello {userData?.fullName || "Guest"}!
          </h3>
        </div>
      </div>
    </>
  );
};

export default ManageAccount;
